import { Component } from '@angular/core';

import actualYear from '../../constants/rights-reserved.constant';

@Component({
    selector: 'mapp-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent {
    actualYear = actualYear;
}
